import Treatment from "@/views/treatments/treatment.vue";
import Treatments from "@/views/treatments/index.vue";

export default [
  {
    path: "tratamentos",
    name: "Tratamentos",
    component: Treatments,
  },
  {
    path: "tratamentos/:treatmentId",
    name: "Editar tratamento",
    props: true,
    component: Treatment,
  },
  {
    path: "tratamentos/:treatmentId/solicitacao/:medicalRequestId",
    name: "Editar tratamento com solicitacao",
    props: true,
    component: Treatment,
  },
];
